<button mat-raised-button class="color createTrainButton" (click)="openCreateTrainModal()">
    <mat-icon class="add">add_box</mat-icon>{{train?.addButton}}
</button>
<button mat-raised-button class="warning" *ngIf="hasDeletedVariantInAnyTrainConfiguration">
    <mat-icon>warning</mat-icon> {{train?.variantWarning}}
    {{warningMessage}}</button>
<div class="trainContainerList">
    <app-train-configuration *ngFor="let train of trainList" [trainData]="train"
        (deleteTrain)="openDeleteTrainModal($event)" (editTrain)="editTrain($event)"
        (copyTrain)="copyTrain($event)" (addTrainPartEvent)="openAddTrainPartDialog($event)"
        (deleteTrainPartEvent)="openDeleteTrainPartModal($event)" (swapTrainPartPlacesEvent)="swapTrainPartPlaces($event)"
        (editTrainPartEvent)="editTrainPart($event)"
        (rotateTrainPartEvent)="rotateTrainPart($event)"></app-train-configuration>
</div>